module.exports = __webpack_public_path__ + "img/clock-2.a8dbcd9c.svg";